export const downloadFileMixin = {
  data() {
    return {
      dataUrl: {},
      chunkFiles: {
        default: [],
        dateRange: [],
        uploadForm: [],
      },
      files: {
        fileRawData: "",
        type: "application/pdf",
        ext: "pdf",
        jobActivity: {
          paynum: "",
        },
        wwChildrenCheck: {
          document_id: "",
        },
      },
      pushTo: "default",
      start_point: 0,
      next_slice: 0,
      percent_done: 0,
      maxUploadSize: 50,
      error_too_big: false,
      uploaded_file_name: "",
      current_file_name: "",
      fileExtension: "",
      mime_type: "",
      finished_uploading: 0,
      uploading_file_started: 0,
      size_of_chunked_file: 0,
    };
  },
  computed: {
    chunk_uploaded_file_into_array(el) {
      if (el.uploaded_file) {
        this.dataUrl = el.uploaded_file;
        this.clone_file = this.dataURLtoBlob;
      }

      // Read the File Upload
      var reader = new FileReader();

      // Define Slicing Size
      var slice_size = 1000 * 1024;
      this.next_slice = this.start_point + slice_size + 1;
      var blob = this.clone_file.slice(this.start_point, this.next_slice);

      // Read Blob Image as DataUrl
      reader.readAsDataURL(blob);

      var thisComponent = this;

      // Execute after reader finishes reading
      reader.onloadend = function (event) {
        if (event.target.readyState !== FileReader.DONE) {
          return;
        }

        // At this point the file data is loaded to event.target.result
        thisComponent.chunkFiles[thisComponent.pushTo].push(
          event.target.result
        );

        if (thisComponent.next_slice < thisComponent.clone_file.size) {
          // Update upload progress
          thisComponent.percent_done = Math.floor(
            (thisComponent.next_slice / thisComponent.clone_file.size) * 100
          );

          // More to upload, call function recursively
          thisComponent.start_point = thisComponent.next_slice;
          thisComponent.chunk_uploaded_file_into_array;
        } else {
          // Update upload progress
          thisComponent.percent_done = 100;

          // let fileExtension = (thisComponent.clone_file.type).split('/')[1];

          // thisComponent.current_file_name = thisComponent.clone_file.name;
          // thisComponent.uploaded_file_name = thisComponent.clone_file.name;
          // thisComponent.fileExtension = fileExtension;
          // thisComponent.mime_type = 'data:' + thisComponent.clone_file.type + ';base64,';
          // thisComponent.isFileUploaded = true;
        }
      };
    },

    dataURLtoBlob() {
      var arr = this.uploaded_file.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    checkIfChunkRequired() {
      let clone_file = this.dataURLtoBlob;

      let slice_size = 1000 * 1024;

      if (clone_file.size > slice_size) {
        this.chunk_uploaded_file_into_array;
      } else {
        this.chunkFiles[this.pushTo].push(this.uploaded_file);
      }

      let fileExtension = this.fileList.info.type.split("/")[1];
      this.current_file_name = this.uploaded_file_name =
        this.fileList.info.name;
      this.fileExtension = fileExtension;
      this.mime_type = "data:" + this.fileList.info.type + ";base64,";
    },

    downloadFile() {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      let newBlob = new Blob([this.files.fileRawData], {
        type: this.files.type,
      });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download =
        "Job Activity Report " +
        this.files[this.pushTo].paynum +
        ".pdf";
      link.click();
      let url = window.URL;
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        url.revokeObjectURL(data);
      }, 100);
    },

    resetAll() {
      this.chunkFiles[this.pushTo] = [];
      this.finished_uploading = 0;
      this.uploading_file_started = 0;
      this.uploaded_file = {};
      this.current_file_name = "";
      this.uploaded_file_name = "";
      this.fileExtension = "";
      this.mime_type = "";
      this.isFileUploaded = false;
      this.loadingTheFile = true;
    },
  },
};
